import client from '@/apis/http-client'
import Vue from 'vue'
import qs from 'qs'

const pathUrl = `/por/api/contact-routings`
const useMockData = false

const mockRoutes = [
  {id: 1, org_codename: '*', form_type: 'contact', notify_email: 'group-contact@hospital.com'},
  {id: 2, org_codename: '*', form_type: 'feedback', notify_email: 'group-feedback@hospital.com'},
  {id: 3, org_codename: '*', form_type: 'complaint', notify_email: 'group-complaint@hospital.com'},
  {id: 4, org_codename: 'psuv', form_type: 'contact', notify_email: 'contact-psuv@hospital.com,manager-psuv@hospital.com'}
]

const normalizeRoute = (item) => ({
  ...item,
  org_codename: item.org_codename || item.org_code || ''
})

const defaultState = () => ({
  currentPage: 1,
  pageSize: 10,
  total: 0,
  sortBy: 'id',
  sortDesc: 'DESC',
  textSearch: '',
  filterFormType: '',
  filterOrgCode: '',
  isLoading: false,
  list: []
})

let state = defaultState()

const actions = {
  resetList({commit}) {
    commit('RESET_LIST_STATE')
  },
  setPage({commit}, page) {
    commit('SET_PAGE', page)
  },
  setPageSize({commit}, size) {
    commit('SET_PAGE_SIZE', size)
  },
  setTextSearch({commit}, text) {
    if (text !== state.textSearch) {
      commit('SET_TEXT_SEARCH', text)
    }
  },
  setFieldSort({commit}, field) {
    commit('SET_FIELD_SORT', field || defaultState().sortBy)
  },
  setSort({commit}, sort) {
    commit('SET_SORT', sort === undefined ? 'DESC' : sort ? 'DESC' : 'ASC')
  },
  setFilterFormType({commit}, formType) {
    commit('SET_FILTER_FORM_TYPE', formType)
  },
  setFilterOrgCode({commit}, orgCode) {
    commit('SET_FILTER_ORG_CODE', orgCode)
  },
  async fetch({commit}) {
    commit('SET_IS_LOADING', true)

    const {
      currentPage,
      pageSize,
      sortBy,
      sortDesc,
      textSearch,
      filterFormType,
      filterOrgCode
    } = state

    try {
      if (useMockData) {
        const data = getMockResult({
          page: currentPage,
          limit: pageSize,
          orderBy: sortBy,
          sort: sortDesc,
          search: textSearch,
          form_type: filterFormType,
          org_codename: filterOrgCode
        })
        commit('SET_LIST', data.results)
        commit('SET_TOTAL', data.total)
      } else {
        const params = {
          page: currentPage,
          limit: pageSize,
          orderBy: sortBy,
          sort: sortDesc,
          search: textSearch,
          form_type: filterFormType,
          org_codename: filterOrgCode
        }

        const response = await client.secureHttpClient.get(pathUrl, {
          params,
          paramsSerializer: localParams => qs.stringify(localParams, {encode: false})
        })

        const resData = response && response.data ? response.data : {}
        const list = resData.results || resData.data || (Array.isArray(resData) ? resData : [])
        const total = resData.total !== undefined ? resData.total : list.length
        commit('SET_LIST', list.map(normalizeRoute))
        commit('SET_TOTAL', total)
      }
    } catch (e) {
      Vue.$log.error(e)
      commit('SET_LIST', [])
      commit('SET_TOTAL', 0)
    }

    commit('SET_IS_LOADING', false)
  },
  async saveRoute(_, payload) {
    try {
      if (useMockData) {
        if (payload.id) {
          const target = mockRoutes.find(item => item.id === payload.id)
          if (target) {
            target.org_codename = payload.org_codename
            target.form_type = payload.form_type
            target.notify_email = payload.notify_email
          }
        } else {
          mockRoutes.unshift({
            id: mockRoutes.length + 1,
            org_codename: payload.org_codename,
            form_type: payload.form_type,
            notify_email: payload.notify_email
          })
        }
      } else if (payload.id) {
        await client.secureHttpClient.put(`${pathUrl}/${payload.id}`, payload)
      } else {
        await client.secureHttpClient.post(pathUrl, payload)
      }
      return {ok: true, message: ''}
    } catch (e) {
      Vue.$log.error(e)
      const message = e?.response?.data?.message || 'Unable to save routing rule'
      return {ok: false, message}
    }
  },
  async deleteRoute(_, id) {
    try {
      if (useMockData) {
        const index = mockRoutes.findIndex(item => item.id === id)
        if (index !== -1) mockRoutes.splice(index, 1)
      } else {
        await client.secureHttpClient.delete(`${pathUrl}/${id}`)
      }
      return true
    } catch (e) {
      Vue.$log.error(e)
      return false
    }
  }
}

const mutations = {
  RESET_LIST_STATE(state) {
    state.currentPage = defaultState().currentPage
    state.pageSize = defaultState().pageSize
    state.textSearch = defaultState().textSearch
    state.sortBy = defaultState().sortBy
    state.sortDesc = defaultState().sortDesc
    state.filterFormType = defaultState().filterFormType
    state.filterOrgCode = defaultState().filterOrgCode
    state.list = []
    state.total = 0
  },
  SET_PAGE(state, page) {
    state.currentPage = page
  },
  SET_PAGE_SIZE(state, size) {
    state.pageSize = size
  },
  SET_TEXT_SEARCH(state, text) {
    state.textSearch = text
  },
  SET_FIELD_SORT(state, field) {
    state.sortBy = field
  },
  SET_SORT(state, sort) {
    state.sortDesc = sort
  },
  SET_FILTER_FORM_TYPE(state, formType) {
    state.filterFormType = formType
  },
  SET_FILTER_ORG_CODE(state, orgCode) {
    state.filterOrgCode = orgCode
  },
  SET_IS_LOADING(state, isLoading) {
    state.isLoading = isLoading
  },
  SET_LIST(state, list) {
    state.list = list
  },
  SET_TOTAL(state, total) {
    state.total = total
  }
}

const getMockResult = params => {
  const {
    page,
    limit,
    orderBy,
    sort,
    search,
    form_type,
    org_codename
  } = params

  let data = [...mockRoutes]

  if (search) {
    const term = search.toLowerCase()
    data = data.filter(item => {
      return (
        item.org_codename.toLowerCase().includes(term) ||
        item.notify_email.toLowerCase().includes(term)
      )
    })
  }

  if (form_type) {
    data = data.filter(item => item.form_type === form_type)
  }

  if (org_codename) {
    data = data.filter(item => item.org_codename === org_codename)
  }

  data.sort((a, b) => {
    const current = `${a[orderBy] || ''}`
    const next = `${b[orderBy] || ''}`
    if (sort === 'ASC') {
      return current.localeCompare(next)
    }
    return next.localeCompare(current)
  })

  const start = (page - 1) * limit
  const end = start + limit

  return {
    total: data.length,
    results: data.slice(start, end)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
